import { headerBgPattern } from './HeaderBgStore.js';

export const updateHeaderBgPattern = (value) => headerBgPattern.update(oldValue => value);
